export const SELECT = 'SELECT_PRODUCTS';
export const SELECT_CATEGORY = 'SELECT_CATEGORY_PRODUCTS';
export const AVAILABLE_CATEGORIES = 'AVAILABLE_CATEGORIES_PRODUCTS';
export const REMOVE = 'REMOVE_PRODUCTS';
export const DEFAULT = 'DEFAULT_PRODUCTS';
export const FETCH_DATA_PENDING = 'FETCH_DATA_PENDING_PRODUCTS';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS_PRODUCTS';
export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR_PRODUCTS';
export const RESET_PRODUCTS = 'RESET_PRODUCTS';

export function fetchDataPending() {
  return {
    type: FETCH_DATA_PENDING
  }
}

export function fetchDataSuccess(data) {
  return {
    type: FETCH_DATA_SUCCESS,
    data: data
  }
}

export function fetchDataError(error) {
  return {
    type: FETCH_DATA_ERROR,
    error: error
  }
}
